"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class VersionedDataKinds {
    static getKeyFromPath(kind, path) {
        return path.startsWith(kind.streamApiPath)
            ? path.substring(kind.streamApiPath.length)
            : undefined;
    }
}
VersionedDataKinds.Features = {
    namespace: 'features',
    streamApiPath: '/flags/',
};
VersionedDataKinds.Segments = {
    namespace: 'segments',
    streamApiPath: '/segments/',
};
exports.default = VersionedDataKinds;
//# sourceMappingURL=VersionedDataKinds.js.map